import { call, put, takeLatest } from 'redux-saga/effects';
import * as api from '../../api';
import * as actions from './actions';
import { trackServiceEvent } from '../../analytics';

export function* getAssignActivityPreferences() {
    const payload = yield call(api.getActivityAssignPreferences);
    if (payload.status === 200) {
        yield put(actions.getActivityAssignPreferencesSuccess(payload.data));
    } else {
        yield put(actions.getActivityAssignPreferencesFailure());
    }
}

export function* getAssignActivityPreferencesSaga() {
    yield takeLatest(actions.GET_ACTIVITY_ASSIGN_PREFERENCE_REQUEST, getAssignActivityPreferences);
}

export function* saveActivityAssignPreferences(request) {
    const response = yield call(api.saveActivityAssignPreferences, request);
    if (response.status === 200) {
        yield put(actions.saveActivityAssignPreferencesSuccess());
    } else {
        yield put(actions.saveActivityAssignPreferencesFailure());
    }
    trackServiceEvent('assignpreference.saved', response.status);
}

export function* saveActivityAssignPreferencesSaga() {
    yield takeLatest(actions.SAVE_ACTIVITY_ASSIGN_PREFERENCE_REQUEST, saveActivityAssignPreferences);
}

export function* resetActivityAssignPreferences(request) {
    const response = yield call(api.resetActivityAssignPreferences, request);
    if (response.status === 200) {
        yield put(actions.resetActivityAssignPreferencesSuccess());
    } else {
        yield put(actions.resetActivityAssignPreferencesFailure());
    }
    trackServiceEvent('assignpreference.reset', response.status);
}

export function* resetActivityAssignPreferencesSaga() {
    yield takeLatest(actions.RESET_ACTIVITY_ASSIGN_PREFERENCE_REQUEST, resetActivityAssignPreferences);
}



// WEBPACK FOOTER //
// ./app/containers/activity-assign-preference/saga.js